type ModalInstanceEntry = { props: unknown; onCloseCallback?: () => void };

const instances = new Map<string, ModalInstanceEntry>();

export const modalInstanceRegistry = {
  set(id: string, entry: ModalInstanceEntry) {
    instances.set(id, entry);
  },
  replace(id: string, props: unknown, onCloseCallback?: () => void) {
    const previous = instances.get(id);

    instances.set(id, { props, onCloseCallback: onCloseCallback ?? previous?.onCloseCallback });
  },
  getProps(id: string) {
    return instances.get(id)?.props;
  },
  getCloseCallback(id: string) {
    return instances.get(id)?.onCloseCallback;
  },
  delete(id: string) {
    instances.delete(id);
  },
  clear() {
    instances.clear();
  },
};
